import {sendMessage} from '../input-field/index';

export const ADD_MESSAGE = 'ADD_MESSAGE';
export const ADD_MESSAGES = 'ADD_MESSAGES';
export const BUTTON_CLICKED = 'BUTTON_CLICK';
export const BUTTON_POSTBACK = 'BUTTON_POSTBACK';
export const BUTTON_URL_OPEN = 'BUTTON_URL_OPEN';

export const addMessage = (message) => ({
  type: ADD_MESSAGE,
  message
});

export const addMessages = (messages) => ({
  type: ADD_MESSAGES,
  messages
});

export const buttonClicked = () => ({
  type: BUTTON_CLICKED
});

export const buttonPostback = () => ({
  type: BUTTON_POSTBACK
});

export const buttonURLOpen = () => ({
  type: BUTTON_URL_OPEN
});

export const clickOnButton = (buttonAttribute) => (dispatch) => {
  switch (buttonAttribute.type) {
    case 'postback':
      dispatch(buttonClicked());
      dispatch(buttonPostback());
      return dispatch(sendMessage({
        'type': 'postback',
        'data': buttonAttribute.data
      }));
    case 'url':
      window.open(buttonAttribute.url);
      dispatch(buttonClicked());
      return dispatch(buttonURLOpen());
    case 'message':
      dispatch(buttonClicked());
      return dispatch(sendMessage({
        'type': 'text',
        'isBot': false,
        'withIcon': true,
        'text': buttonAttribute.text,
        'time': '22:22'
      }));
  }
  return dispatch(buttonClicked());
};



// WEBPACK FOOTER //
// ./src/actions/chat-body/index.js